import React from "react";
import { IntervalClickHandler } from "../types";

export const IntervalClickHandlerContext = React.createContext<IntervalClickHandler<any, any>>(() => {});
